import { FeatureFlags, FeatureFlagsRouteDataObject } from '../models';

export function setupFeatureFlagsForModule(featureFlags: FeatureFlags): FeatureFlagsRouteDataObject {
  return { featureFlags };
}
